import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useRef } from 'react'
import { Spinner } from 'react-bootstrap'

import { useIsMinWidthMd } from '../../../../../../hooks/useIsMinWidthMd'
import { isMacOS } from '../../../../../../lib/helpers/miscHelpers'
import PlainButton from '../../../../PlainButton'
import { GLOBAL_SEARCH_INPUT_DOM_ID } from '../../../constants'
import { useGlobalSearch } from '../../../hooks/useGlobalSearch'

interface Props {
  isLoading: boolean
}

const SearchInput: React.FC<Props> = ({ isLoading }) => {
  const globalSearch = useGlobalSearch()
  const shouldShowClearButton = globalSearch.searchTerm && !isLoading
  const isMinWidthMd = useIsMinWidthMd()
  const inputRef = useRef<HTMLInputElement | null>(null)

  function handleClearInput() {
    globalSearch.clear()

    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  function renderIcon() {
    if (isLoading) {
      return <Spinner size="sm" variant="light" />
    }

    if (shouldShowClearButton) {
      return (
        <PlainButton
          onClick={handleClearInput}
          className="text-center hover-dim text-white"
          title="Clear search"
          style={{
            fontSize: '20px',
            width: '24px',
            lineHeight: '24px',
            marginRight: '-3px',
            height: '24px',
          }}
        >
          ×
        </PlainButton>
      )
    }

    return null
  }

  function renderPlaceholder() {
    let placeholder = 'Search'

    if (isMinWidthMd) {
      placeholder += isMacOS() ? ' (⌘K)' : ' (Ctrl+/)'
    }

    return placeholder
  }

  return (
    <div className="d-flex align-items-center position-relative w-100 mw-100">
      <FontAwesomeIcon
        icon={faSearch}
        className="d-none d-md-block position-absolute text-muted"
        style={{
          top: '50%',
          transform: 'translateY(-50%)',
          left: '15px',
          fontSize: '14px',
        }}
      />

      <input
        ref={inputRef}
        placeholder={renderPlaceholder()}
        className="form-control mw-100 text-sm"
        id={GLOBAL_SEARCH_INPUT_DOM_ID}
        onFocus={globalSearch.show}
        style={{
          paddingLeft: isMinWidthMd ? '40px' : undefined,
          paddingRight: '38px',
          outline: 'none !important',
        }}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            inputRef.current?.blur()
            globalSearch.hide()
          }
        }}
        value={globalSearch.searchTerm}
        onChange={(event) => {
          globalSearch.setSearchTerm(event.target.value)
        }}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
      />

      <div
        className="position-absolute d-flex align-items-center"
        style={{ top: '50%', transform: 'translateY(-50%)', right: '11px' }}
      >
        {renderIcon()}
      </div>
    </div>
  )
}

export default SearchInput
